// extracted by mini-css-extract-plugin
export default {"instruction":"gift-message_instruction__e5764","stats":"gift-message_stats__e3117","messageContainer":"gift-message_messageContainer__69d97"};